export const ICONS = [
  { name: 'ic-acc-opening', path: 'assets/icons/icon-acc-opening.svg' },
  {
    name: 'ic-account-services',
    path: 'assets/icons/icon-account-services-card.svg',
  },
  {
    name: 'ic-customer-360',
    path: 'assets/icons/icon-customer-360.svg',
  },
  {
    name: 'ic-additional-account',
    path: 'assets/icons/icon-additional-account.svg',
  },
  { name: 'ic-agency', path: 'assets/icons/icon-agent.svg' },
  { name: 'ic-alerts', path: 'assets/icons/icon-notifications.svg' },
  { name: 'ic-alerts-off', path: 'assets/icons/icon-bell.svg' },
  {
    name: 'ic-american-express',
    path: 'assets/icons/icon-american-express.svg',
  },
  { name: 'ic-amend', path: 'assets/icons/icon-ammend.svg' },
  { name: 'ic-application', path: 'assets/icons/icon-application.svg' },
  { name: 'ic-arrow', path: 'assets/icons/icon-arrow.svg' },
  { name: 'ic-arrow-down', path: 'assets/icons/icon-arrow-down.svg' },
  {
    name: 'ic-arrow-down-balance',
    path: 'assets/icons/icon-arrow-down-balance.svg',
  },
  {
    name: 'ic-system-update-alt',
    path: 'assets/icons/icon-system-update-alt.svg',
  },
  {
    name: 'ic-arrow-forward',
    path: 'assets/icons/icon-arrow-forward.svg',
  },
  { name: 'ic-arrow-green', path: 'assets/images/UnionupGreen.svg' },
  { name: 'ic-arrow-red', path: 'assets/images/UniondownRed.svg' },
  { name: 'ic-arrow-right', path: 'assets/icons/icon-arrow-right.svg' },
  { name: 'ic-arrow-up', path: 'assets/icons/icon-arrow-up.svg' },
  {
    name: 'ic-arrow-up-balance',
    path: 'assets/icons/icon-arrow-up-balance.svg',
  },
  { name: 'ic-attempts', path: 'assets/icons/icon-attempts.svg' },
  { name: 'ic-avatar', path: 'assets/icons/icon-avatar.svg' },
  { name: 'ic-back-arrow', path: 'assets/icons/icon-back-arrow.svg' },
  { name: 'ic-bio-enrolled', path: 'assets/icons/icon-bio-enrolled.svg' },
  {
    name: 'ic-bio-enrolled-not',
    path: 'assets/icons/icon-bio-enrolled-not.svg',
  },
  {
    name: 'ic-bio-not-enrolled',
    path: 'assets/icons/icon-bio-not-enrolled.svg',
  },
  { name: 'ic-block', path: 'assets/icons/icon-block.svg' },
  { name: 'ic-block-dark', path: 'assets/icons/icon-block-dark.svg' },
  { name: 'ic-block-red', path: 'assets/icons/icon-block-red.svg' },
  { name: 'ic-blocked', path: 'assets/icons/icon-blocked.svg' },
  { name: 'ic-buy', path: 'assets/icons/icon-buy-card.svg' },
  { name: 'ic-cancel-red', path: 'assets/icons/icon-cancel-red.svg' },
  { name: 'ic-card', path: 'assets/icons/icon-card.svg' },
  { name: 'ic-card-blocked', path: 'assets/icons/icon-card-blocked.svg' },
  { name: 'ic-card-credit', path: 'assets/icons/icon-card-credit.svg' },
  { name: 'ic-card-inside', path: 'assets/icons/icon-card-inside.svg' },
  { name: 'ic-card-pin', path: 'assets/icons/icon-card-pin.svg' },
  { name: 'ic-card-prepaid', path: 'assets/icons/icon-card-prepraid.svg' },
  { name: 'ic-category', path: 'assets/icons/icon-category.svg' },
  { name: 'ic-change-limit', path: 'assets/icons/icon-change-limit.svg' },
  { name: 'ic-chart', path: 'assets/icons/icon-chart.svg' },
  { name: 'ic-check', path: 'assets/icons/icon-check.svg' },
  { name: 'ic-circle-check', path: 'assets/icons/icon-circle-check.svg' },
  {
    name: 'ic-circle-check-secondary',
    path: 'assets/icons/icon-circle-check-secondary.svg',
  },
  {
    name: 'ic-circle-green-check',
    path: 'assets/icons/icon-circle-green-check.svg',
  },
  { name: 'ic-clock', path: 'assets/icons/icon-clock.svg' },
  { name: 'ic-close', path: 'assets/icons/icon-close.svg' },
  { name: 'ic-close-sm', path: 'assets/icons/icon-close-sm.svg' },
  { name: 'ic-communication', path: 'assets/icons/icon-communication.svg' },
  { name: 'ic-configure', path: 'assets/icons/icon-configure.svg' },
  {
    name: 'ic-configure-disabled',
    path: 'assets/icons/icon-configure-disabled.svg',
  },
  { name: 'ic-conversation', path: 'assets/icons/icon-conversation.svg' },
  { name: 'ic-cool-off', path: 'assets/icons/icon-cool-off.svg' },
  { name: 'ic-corporate', path: 'assets/icons/icon-corporate.svg' },
  { name: 'ic-credit-card', path: 'assets/icons/icon-card.svg' },
  { name: 'ic-customer-360', path: 'assets/icons/icon-customer-360.svg' },
  { name: 'ic-customer-search', path: 'assets/icons/icon-customer-search.svg' },
  {
    name: 'ic-customer-search-caret',
    path: 'assets/icons/icon-customer-search-caret.svg',
  },
  { name: 'ic-dashboard', path: 'assets/icons/icon-home.svg' },
  { name: 'ic-delete', path: 'assets/icons/icon-delete.svg' },
  { name: 'ic-delete-update', path: 'assets/icons/icon-delete-update.svg' },
  { name: 'ic-deposit', path: 'assets/icons/icon-deposit-cash.svg' },
  { name: 'ic-document', path: 'assets/icons/icon-document.svg' },
  { name: 'ic-dollar', path: 'assets/icons/icon-dollar.svg' },
  { name: 'ic-duplicate', path: 'assets/icons/icon-duplicate.svg' },
  { name: 'ic-edit', path: 'assets/icons/icon-edit.svg' },
  { name: 'ic-error', path: 'assets/icons/icon-error.svg' },
  { name: 'ic-error-open', path: 'assets/icons/icon-error-open.svg' },
  { name: 'ic-euro', path: 'assets/icons/icon-euro.svg' },
  { name: 'ic-exchange', path: 'assets/icons/icon-exchange.svg' },
  {
    name: 'ic-exclamation-gray',
    path: 'assets/icons/icon-exclamation-gray.svg',
  },
  { name: 'ic-exclamation-red', path: 'assets/icons/icon-exclamation-red.svg' },
  { name: 'ic-exclamation-white', path: 'assets/icons/icon-exclamation-white.svg' },
  { name: 'ic-eye', path: 'assets/icons/icon-eye.svg' },
  { name: 'ic-feature', path: 'assets/icons/icon-feature.svg' },
  { name: 'ic-file-download', path: 'assets/icons/icon-file-download.svg' },
  { name: 'ic-filter', path: 'assets/icons/icon-filter.svg' },
  { name: 'ic-filter-funnel', path: 'assets/icons/icon-filter-funnel.svg' },
  { name: 'ic-flag-drc', path: 'assets/icons/icon-flag-drc.svg' },
  { name: 'ic-flag-euro', path: 'assets/icons/icon-flag-euro.svg' },
  { name: 'ic-flag-ke', path: 'assets/icons/icon-flag-ke.svg' },
  { name: 'ic-flag-rw', path: 'assets/icons/icon-flag-rw.svg' },
  { name: 'ic-flag-s-sudan', path: 'assets/icons/icon-flag-ssudan.svg' },
  { name: 'ic-flag-tz', path: 'assets/icons/icon-flag-tz.svg' },
  { name: 'ic-flag-ug', path: 'assets/icons/icon-flag-ug.svg' },
  { name: 'ic-flag-uk', path: 'assets/icons/icon-flag-uk.svg' },
  { name: 'ic-flag-usa', path: 'assets/icons/icon-flag-usa.svg' },
  {
    name: 'ic-fp-not-captured',
    path: 'assets/icons/icon-fingerprint-not-captured.svg',
  },
  { name: 'ic-generic-avatar', path: 'assets/icons/icon-generic-avatar.svg' },
  { name: 'ic-green-tick', path: 'assets/icons/icon-green-tick.svg' },
  { name: 'ic-green-up', path: 'assets/icons/icon-green-up.svg' },
  { name: 'ic-group', path: 'assets/icons/icon-group.svg' },
  { name: 'ic-guage', path: 'assets/icons/icon-guage.svg' },
  { name: 'ic-handshake', path: 'assets/icons/icon-corporate.svg' },
  { name: 'ic-health', path: 'assets/icons/icon-health.svg' },
  { name: 'ic-help', path: 'assets/icons/icon-help.svg' },
  { name: 'ic-icon-eye-hide', path: 'assets/icons/icon-eye-hide.svg' },
  { name: 'ic-info', path: 'assets/icons/icon-info.svg' },
  { name: 'ic-info-down', path: 'assets/icons/icon-info-down.svg' },
  { name: 'ic-insurance', path: 'assets/icons/icon-insurance.svg' },
  { name: 'ic-laptop', path: 'assets/icons/icon-laptop.svg' },
  { name: 'ic-loan', path: 'assets/icons/icon-loan.svg' },
  { name: 'ic-mastercard', path: 'assets/icons/icon-mastercard.svg' },
  { name: 'ic-message', path: 'assets/icons/icon-message.svg' },
  { name: 'ic-microsoft', path: 'assets/icons/icon-microsoft.svg' },
  { name: 'ic-more', path: 'assets/icons/icon-more.svg' },
  { name: 'ic-more-circle', path: 'assets/icons/icon-more-circle.svg' },
  { name: 'ic-more-colored', path: 'assets/icons/icon-more-colored.svg' },
  { name: 'ic-more-primary', path: 'assets/icons/icon-more-primary.svg' },
  { name: 'ic-more-vertical', path: 'assets/icons/icon-more-vertical.svg' },
  { name: 'ic-nav', path: 'assets/icons/icon-nav.svg' },
  { name: 'ic-new-loan', path: 'assets/icons/icon-new-loan.svg' },
  { name: 'ic-no-data', path: 'assets/icons/icon-no-data.svg' },
  {
    name: 'ic-no-records-found',
    path: 'assets/icons/icon-no-records-found.svg',
  },
  { name: 'ic-no-results', path: 'assets/icons/icon-no-results.svg' },
  {
    name: 'ic-not-found-illustration',
    path: 'assets/icons/icon-not-found-illustration.svg',
  },
  { name: 'ic-one-red', path: 'assets/icons/icon-one-red.svg' },
  { name: 'ic-opt-card', path: 'assets/icons/icon-account-option-card.svg' },
  { name: 'ic-pay', path: 'assets/icons/icon-pay-card.svg' },
  { name: 'ic-person', path: 'assets/icons/icon-person.svg' },
  { name: 'ic-person-white', path: 'assets/icons/icon-person-white.svg' },
  { name: 'ic-placeholder', path: 'assets/icons/icon-placeholder.svg' },
  {
    name: 'ic-placeholder-darker',
    path: 'assets/icons/icon-placeholder-darker.svg',
  },
  {
    name: 'ic-placeholder-portrait',
    path: 'assets/icons/icon-placeholder-potrait.svg',
  },
  {
    name: 'ic-placeholder-portrait-lg',
    path: 'assets/icons/icon-placeholder-potrait-lg.svg',
  },
  {
    name: 'ic-placeholder-potrait',
    path: 'assets/icons/icon-placeholder-potrait.svg',
  },
  { name: 'ic-plus', path: 'assets/icons/icon-plus.svg' },
  { name: 'ic-pound', path: 'assets/icons/icon-pound.svg' },
  { name: 'ic-print', path: 'assets/icons/icon-print.svg' },
  { name: 'ic-profile-company', path: 'assets/icons/icon-profile-company.svg' },
  { name: 'ic-radiobutton', path: 'assets/icons/icon-radiobutton.svg' },
  { name: 'ic-receive-money', path: 'assets/icons/icon-receive-money.svg' },
  { name: 'ic-received-tick', path: 'assets/icons/icon-received-request.svg' },
  { name: 'ic-red-down', path: 'assets/icons/icon-red-down.svg' },
  { name: 'ic-red-info', path: 'assets/icons/icon-red-info.svg' },
  {
    name: 'ic-register-service',
    path: 'assets/icons/icon-register-service.svg',
  },
  { name: 'ic-reset-pin', path: 'assets/icons/icon-reset-pin.svg' },
  { name: 'ic-retry-gray', path: 'assets/icons/icon-retry-gray.svg' },
  { name: 'ic-retry-primary', path: 'assets/icons/icon-retry-primary.svg' },
  { name: 'ic-right-arrow', path: 'assets/icons/icon-right-arrow.svg' },
  { name: 'ic-search', path: 'assets/icons/icon-search.svg' },
  { name: 'ic-search-bio', path: 'assets/icons/icon-search-bio.svg' },
  { name: 'ic-search-color', path: 'assets/images/Unionsearch.svg' },
  { name: 'ic-section-done', path: 'assets/icons/icon-section-done.svg' },
  {
    name: 'ic-send-receive-money',
    path: 'assets/icons/icon-send-receive-money.svg',
  },
  { name: 'ic-sent-tick', path: 'assets/icons/icon-sent-request.svg' },
  { name: 'ic-service-request', path: 'assets/icons/icon-service-request.svg' },
  { name: 'ic-settings', path: 'assets/icons/icon-settings.svg' },
  { name: 'ic-shilling', path: 'assets/icons/icon-shiling.svg' },
  { name: 'ic-signal', path: 'assets/icons/icon-signal.svg' },
  { name: 'ic-smartphone', path: 'assets/icons/icon-smartphone.svg' },
  { name: 'ic-statement', path: 'assets/icons/icon-statement.svg' },
  { name: 'ic-status-pending', path: 'assets/icons/icon-status-pending.svg' },
  { name: 'ic-status-received', path: 'assets/icons/icon-status-received.svg' },
  { name: 'ic-status-sent', path: 'assets/icons/icon-status-sent.svg' },
  { name: 'ic-stroke', path: 'assets/icons/icon-stroke.svg' },
  { name: 'ic-success', path: 'assets/icons/icon-success.svg' },
  { name: 'ic-tab-bar', path: 'assets/icons/icon-tab-bar.svg' },
  { name: 'ic-teller-service', path: 'assets/icons/icon-teller-service.svg' },
  { name: 'ic-tick-black', path: 'assets/images/Unioncheck.svg' },
  { name: 'ic-tick-primary', path: 'assets/icons/icon-tick-primary.svg' },
  { name: 'ic-time', path: 'assets/images/Uniontime.svg' },
  { name: 'ic-toggle-slider', path: 'assets/icons/icon-toggle-slider.svg' },
  {
    name: 'ic-transact-profile',
    path: 'assets/icons/icon-transact-profile.svg',
  },
  { name: 'ic-transfer', path: 'assets/icons/icon-transfer-card.svg' },
  { name: 'ic-trash', path: 'assets/icons/icon-trash.svg' },
  { name: 'ic-union', path: 'assets/icons/icon-union.svg' },
  {
    name: 'ic-unverified-caution',
    path: 'assets/icons/icon-unverified-caution.svg',
  },
  { name: 'ic-update', path: 'assets/icons/icon-update.svg' },
  { name: 'ic-update-profile', path: 'assets/icons/icon-update-profile.svg' },
  { name: 'ic-upload', path: 'assets/icons/icon-upload.svg' },
  {
    name: 'ic-uploadBackground',
    path: 'assets/icons/icon-uploadBackground.svg',
  },
  { name: 'ic-verified-tick', path: 'assets/icons/icon-verified-tick.svg' },
  { name: 'ic-view', path: 'assets/icons/icon-view.svg' },
  { name: 'ic-visa', path: 'assets/icons/icon-visa.svg' },
  { name: 'ic-visual-support', path: 'assets/icons/icon-visual-support.svg' },
  { name: 'ic-warn-circle', path: 'assets/icons/icon-warning-circle.svg' },
  { name: 'ic-warning-caution', path: 'assets/icons/icon-warning-caution.svg' },
  { name: 'ic-withdraw', path: 'assets/icons/icon-withdraw.svg' },
  { name: 'ic-radio-button-off', path: 'assets/icons/radio-button-off.svg' },
  { name: 'ic-copy', path: 'assets/icons/icon-duplicate.svg' },
  { name: 'ic-cancel', path: 'assets/icons/icon-cancel.svg' },
  { name: 'ic-reports', path: 'assets/icons/icon-statement.svg' },
  { name: 'ic-administration', path: 'assets/icons/icon-settings.svg' },
  { name: 'ic-funnel-filter', path: 'assets/icons/icon-filter-funnel.svg' },
  { name: 'ic-grid-dots', path: 'assets/icons/icon-nav.svg' },
  { name: 'ic-legal-search-okey', path: 'assets/icons/icon-circle-green-check.svg' },
  { name: 'ic-legal-search-not-okey', path: 'assets/icons/icon-exclamation-red.svg' },
  { name: 'ic-legal-search-pending', path: 'assets/icons/icon-clock.svg' },
  { name: 'ic-link', path: 'assets/icons/icon-union.svg' },
  { name: 'ic-tickets', path: 'assets/icons/icon-tickets.svg' },
  { name: 'ic-corprate-services', path: 'assets/icons/icon-corporate-services.svg' },
  { name: 'ic-credit-services', path: 'assets/icons/icon-loan.svg' },
  { name: 'ic-agency-services', path: 'assets/icons/icon-agent.svg' },
  { name: 'ic-special-projects', path: 'assets/icons/icon-folder.svg' },
  { name: 'ic-menu-insurance', path: 'assets/icons/icon-insurance.svg' },
  { name: 'ic-custody', path: 'assets/icons/icon-shield.svg' },
  { name: 'ic-foreign-exchange', path: 'assets/icons/icon-chart.svg' },
  { name: 'ic-movemoney-send-own-account', path: 'assets/icons/icon-send-receive-money.svg' },
  { name: 'ic-movemoney-send-equity-bank', path: 'assets/icons/icon-send-receive-money.svg' },
  { name: 'ic-movemoney-send-other-bank', path: 'assets/icons/icon-transfer-card.svg' },
  { name: 'ic-movemoney-send-linked', path: 'assets/icons/icon-receive-money.svg' },
  { name: 'ic-movemoney-send-international', path: 'assets/icons/icon-exchange.svg' },
  { name: 'ic-movemoney-send-bulk', path: 'assets/icons/icon-send-receive-money.svg' },
  { name: 'ic-movemoney-send-swift', path: 'assets/icons/icon-exchange.svg' },
  { name: 'ic-movemoney-reorder', path: 'assets/icons/icon-update.svg' },
  { name: 'ic-standing-order', path: 'assets/icons/icon-clock.svg' },
];
